import { JSX } from 'react'

import { spinnerVariants } from '~/components/component-library/LoadingSpinner/styles'
import { type LoadingSpinnerProps } from '~/components/component-library/LoadingSpinner/types'

export { type LoadingSpinnerProps } from '~/components/component-library/LoadingSpinner/types'

export const LoadingSpinner = ({ size }: LoadingSpinnerProps): JSX.Element => (
  <div className={spinnerVariants({ size })} />
)
